import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DraftProfileState {
  draftProfileSessionId: string | null;
  draftProfileEmail: string | null;
  draftProfileIntent: "candidate" | "company" | null;
  draftProfileCompanyName: string | null;
  setDraftProfileSessionId: (id: string | null) => void;
  setDraftProfileEmail: (email: string | null) => void;
  setDraftProfileIntent: (intent: "candidate" | "company" | null) => void;
  setDraftProfileCompanyName: (email: string | null) => void;
}

export const useDraftProfileStore = create<DraftProfileState>()(
  persist(
    (set) => ({
      draftProfileSessionId: null,
      draftProfileEmail: null,
      draftProfileIntent: null,
      draftProfileCompanyName: null,
      setDraftProfileSessionId: (id) => set({ draftProfileSessionId: id }),
      setDraftProfileEmail: (email) => set({ draftProfileEmail: email }),
      setDraftProfileIntent: (intent) => set({ draftProfileIntent: intent }),
      setDraftProfileCompanyName: (name) =>
        set({ draftProfileCompanyName: name }),
    }),
    {
      name: "draft-profile-storage",
    },
  ),
);
